/******************************************************************************
 * @Author                : Hamza Damene                                      *
 * @CreatedDate           : 2025-03-19 15:00:00                               *
 * @LastEditors           : Hamza Damene                                      *
 * @LastEditDate          : 2025-03-19 15:00:00                               *
 *****************************************************************************/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { useTranslation } from "react-i18next";
import { useWorkorderInformation } from "../../../../../hooks/useWorkorderInformation";

/**
 * Props pour le composant TimeSection
 */
interface TimeSectionProps {
  workorder: EasyTech.Workorder;
  informationHook: ReturnType<typeof useWorkorderInformation>;
}

/**
 * Section du temps réel d'exécution du workorder
 * @param workorder - Données du workorder
 * @param informationHook - Hook contenant la logique d'édition
 * @returns Composant React pour la section du temps réel
 */
export function TimeSection({ workorder, informationHook }: TimeSectionProps) {
  const { t } = useTranslation();
  const {
    formData,
    formatDuration,
  } = informationHook;

  return (
    <>
      <div className="field">
        <Typography variant="small">{t("workorder:date.real_start")}</Typography>
        <Typography>
          {workorder?.time?.start
            ? new Date(workorder.time.start).toLocaleString()
            : "-"}
        </Typography>
      </div>

      <div className="field">
        <Typography variant="small">{t("workorder:date.real_end")}</Typography>
        <Typography>
          {workorder?.time?.end
            ? new Date(workorder.time.end).toLocaleString()
            : "-"}
        </Typography>
      </div>

      <div className="field">
        <Typography variant="small">{t("workorder:date.real_duration")}</Typography>
        <Typography>
          {formatDuration(Number(formData.time.duration || 0))}
        </Typography>
      </div>

      <div className="field">
        <Typography variant="small">{t("workorder:date.travel_time")}</Typography>
        <Typography>
          {formatDuration(Number(workorder?.travelTime?.duration || 0))}
        </Typography>
      </div>
    </>
  );
}
